import { Link } from "react-router-dom";

export function LegalFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white/70 mt-12" data-testid="legal-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-[11px] leading-snug text-slate-500">
        <p className="max-w-3xl">
          First Step is an independent study and preparation platform — not a fire department, certification agency, testing organization, academy or government body, and not affiliated with or endorsed by the NREMT, IFSTA, Pro Board, FCTC, the CPAT program or any agency. It helps you prepare; it does not guarantee passing an exam or interview, certification, or employment. Interview feedback, resume suggestions, fitness plans, food estimates and Road Map tips are AI-assisted general guidance that may contain errors — not medical, nutritional, legal or professional advice.
        </p>
        <div className="flex flex-wrap gap-4 shrink-0 font-semibold">
          <Link to="/terms#terms" className="hover:text-primary" data-testid="footer-terms-link">Terms</Link>
          <Link to="/terms#privacy" className="hover:text-primary" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/terms#ai" className="hover:text-primary" data-testid="footer-ai-link">AI Disclosure</Link>
          <span>© {new Date().getFullYear()} First Step</span>
        </div>
      </div>
    </footer>
  );
}
